import {
  Injectable
} from '@angular/core';

import {
  BehaviorSubject
} from 'rxjs';

export interface SidebarActiveState {
  context: 'active' | 'archived' | 'removed';
  isCostLists: boolean;
  isWms: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class SidebarService {
  private activeStateSubject = new BehaviorSubject<SidebarActiveState>(
    null
  );

  public activeState$ = (
    this.activeStateSubject
        .asObservable()
  );

  public setActiveState(
    activeState: SidebarActiveState
  ) {
    this.activeStateSubject
        .next(
          activeState
        );
  }

  public clearActiveState() {
    this.activeStateSubject
        .next(
          null
        );
  }
}
